import React, { useContext, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import {
  FaSearch,
  FaUserCheck,
  FaEye,
  // FaCheck,
  // FaTimes,
  FaInfoCircle,
} from 'react-icons/fa';
import { ReportContext } from '../ReportContext';
import { AuthContext } from '../../auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import RequestRevision from './forms/RequestRevision';
import ApproveProposal from './forms/ApproveProposal';
import ReadOnlyEditor from '../../components/tiptap-templates/simple/read-only-editor';
import { Box } from '@mui/material';

export default function ProposedSolutions() {
  const { issues } = useContext(ReportContext);
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate()

  const [filteredSolutions, setFilteredSolutions] = useState([]);
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [reload, setReload] = useState(false);
  const pageSize = 5;



  useEffect(() => {
    if (Array.isArray(issues) && currentUser?.id) {
      const filtered = issues
        .filter(issue => issue.solution?.status === 'Proposed'
          && issue?.admin_id === currentUser?.id
        )
        .map(issue => ({
          ...issue.solution,
          issueCategory: issue.category,
          issue_id: issue.issue_id,
        }));
      setFilteredSolutions(filtered);
    }
  }, [issues, currentUser, reload]);

  const searchedSolutions = Array.isArray(filteredSolutions) && filteredSolutions.filter(solution => {
    const text = ` ${solution.issueCategory} ${solution.proposal_notes} ${solution.assigned_to?.name}  ${solution.assigned_to?.organisation}  ${solution.assigned_to?.email}`.toLowerCase();
    return text.includes(search.toLowerCase());
  });

  const paginated = Array.isArray(searchedSolutions) && searchedSolutions.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
  const totalPages = Math.ceil(searchedSolutions.length / pageSize);

  return (
    <motion.div
      className="container my-5"
      initial={{ opacity: 0, y: 60 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      {/* Header */}
      <motion.div
        className="d-flex align-items-center justify-content-center text-light mb-4 gap-3 position-relative"
        initial={{ opacity: 0, x: -30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.2 }}
      >
        <FaUserCheck  size={28} />
        <h1 className=" fw-bold mb-0">Proposed Solutions</h1>
        <button 
        className='btn btn-outline-danger position-absolute end-0 top-0 m-2'
        onClick={()=> window.history.back()}
        >❌</button>
      </motion.div>

      {/* Search Bar */}
      <motion.div
        className="mb-4 container  "
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.3 }}
      >
        <div className="input-group shadow-sm d-flex justify-content-center ">
          <span className="input-group-text bg-light border-end-0">
            <FaSearch className="text-muted" />
          </span>
          <input
            type="search"            
            className="form-control border-start-0"
            placeholder="Search by issue or proposal notes..."
            value={search}
            style={{maxWidth:'400px'}}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>
      </motion.div>

      {/* Table */}
      <motion.div
        className="table-responsive border rounded shadow-sm p-3"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
      >
        <table className="table table-hover table-bordered mb-0">
          <thead className="table-success text-center">
            <tr>
              <th>#</th>
              <th>Main Issue</th>
              <th>Proposal Notes</th>
              <th>Assigned To</th>
              <th>Revision Requested</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody className="text-center">
            {paginated.length > 0 ? (
              Array.isArray(paginated) && paginated.map((sol, idx) => (
                <motion.tr
                  key={idx}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2 + idx * 0.1 }}
                >
                  <td>{(currentPage - 1) * pageSize + idx + 1}</td>
                  <td>
                    <strong>{sol.issueCategory || 'N/A'}</strong>
                    <br />
                    <small className="text-muted">{sol.issue_id}</small>
                  </td>
                  <td className="text-start">
                    {/* <p style={{ whiteSpace: 'pre-wrap' }}>{sol.proposal_notes}</p> */}
                    <Box sx={{ width: "100%", height: "100%", bgcolor: "white", borderRadius: 2, p: 2, boxShadow: 1 }}>
                      <ReadOnlyEditor content={sol.proposal_notes}/>
                    </Box>
                    <small className="text-primary">
                      {new Date(sol.proposed_at).toLocaleDateString()}
                    </small>
                  </td>
                  <td>
                    <strong>{sol.assigned_to?.name || 'N/A'}</strong>
                    <br />
                    <small className="text-muted">{sol.assigned_to?.organisation}</small>
                    <br />
                    <small>
                      <a href={`mailto:${sol.assigned_to?.email}`}>
                        {sol.assigned_to?.email}
                      </a>
                    </small>
                  </td>
                  <td>
                    {sol.revision_notes ? (
                      <>
                        {/* <p style={{ whiteSpace: 'pre-wrap' }}>{sol.revision_notes}</p> */}
                        <Box sx={{ width: "100%", height: "100%", bgcolor: "white", borderRadius: 2, p: 2, boxShadow: 1 }}>
                          <ReadOnlyEditor content={sol.revision_notes || "N/A"} />
                        </Box>
                        <small className="text-primary">
                          {new Date(sol.revision_requested_at).toLocaleDateString()}
                        </small>
                      </>
                    ) : (
                      <FaInfoCircle className="text-muted" title="No revision requested" />
                    )}
                  </td>
                  <td>
                    <div className="d-flex justify-content-center gap-2">
                      <button 
                      className="btn btn-outline-primary btn-sm" 
                      title="View Issue"
                      onClick={()=> navigate(`/issues/${sol?.issue_id}`)}
                      >
                        <FaEye />
                      </button>
                      <ApproveProposal solutionId={sol?.solution_id} reload={reload} setReload={setReload} />
                      <RequestRevision solutionId={sol?.solution_id} reload={reload} setReload={setReload} />
                    </div>
                  </td>
                </motion.tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center ">
                 <div className="alert alert-info py-4"> No proposed solutions found.</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </motion.div>

      {/* Pagination */}
      {totalPages > 1 && (
        <motion.nav
          className="mt-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <ul className="pagination justify-content-center">
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <button className="page-link" onClick={() => setCurrentPage(1)}>First</button>
            </li>
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <button
                className="page-link"
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
              >
                Prev
              </button>
            </li>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
              <li key={page} className={`page-item ${page === currentPage ? 'active' : ''}`}>
                <button className="page-link" onClick={() => setCurrentPage(page)}>
                  {page}
                </button>
              </li>
            ))}
            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
              <button
                className="page-link"
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
              >
                Next
              </button>
            </li>
            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
              <button className="page-link" onClick={() => setCurrentPage(totalPages)}>Last</button>
            </li>
          </ul>
        </motion.nav>
      )}
    </motion.div>
  );
}
